import Button from "@app/components/button";
import { FormControl } from "@app/components/form-control";
import Input from "@app/components/input";
import TextArea from "@app/components/textarea";
import { addToast } from "@app/components/toast/toast.service";
import { RoutePath, SystemMessage } from "@app/constants";
import SettingService from "@app/services/http/setting.service";
import { Setting, UpdateSetting } from "@app/types";
import useForceUpdate from "@core/hooks/use-force-update.hook";
import { Form, Formik, FormikContextType } from "formik";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const UpdateSettingPage = () => {
  const { settingId } = useParams();
  const [settingInfo, setSettingInfo] = useState<Setting>();
  const formRef = useRef<FormikContextType<UpdateSetting>>(null);
  const [update, forceUpdate] = useForceUpdate();
  const navigate = useNavigate();

  useEffect(() => {
    SettingService.getSettingById(Number(settingId)).then((res) => {
      setSettingInfo(res.data);
    });
  }, [update]);

  const handleSubmit = async (values: UpdateSetting) => {
    await SettingService.update(Number(settingId), values);

    addToast({ text: SystemMessage.UPDATE_SUCCESSFULLY });
    forceUpdate();
  };

  const gotoListSetting = () => {
    navigate(`/${RoutePath.SETTING_MANAGEMENT}`);
  };

  return (
    <div className="py-6 px-12">
      <div className="flex justify-between items-center ">
        <div className="text-[#343C6A]">Danh sách setting / Sửa</div>
      </div>

      <Formik
        innerRef={formRef}
        initialValues={{
          name: settingInfo?.name ?? "",
          value: settingInfo?.value ?? "",
        }}
        onSubmit={handleSubmit}
        validateOnChange
        validateOnBlur
        enableReinitialize
      >
        {() => (
          <Form>
            <div className="mt-6 rounded-xl bg-white py-6 px-5">
              <div className="w-[100%] max-w-[700px]">
                <FormControl name="name">
                  <Input className="mt-7" placeholder="Tên setting" />
                </FormControl>
                <FormControl name="value">
                  <TextArea
                    width={700}
                    className="mt-7 mb-2"
                    placeholder="Value"
                  />
                </FormControl>
              </div>
            </div>
            <div className="mt-6 flex justify-left gap-4">
              <Button
                type="submit"
                size="xs"
                label={"Lưu"}
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
              />
              <Button
                size="xs"
                label="Hủy"
                theme="secondary"
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
                onClick={gotoListSetting}
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default UpdateSettingPage;
